import React from 'react'
import _ from 'lodash'
import { startLoading, stopLoading } from 'src/redux/slices/loading'
import { stopQueueWaiting } from 'src/redux/slices/queue'
import { getLearnerDocument, getRegisterDocument } from 'src/services/document'
import {
  openDialog,
  openErrorDialog,
  openSuccessDialog,
  stopLoadingDialog,
} from 'src/redux/slices/alertDialog'
import { MONTH_TH_SHORT_LIST } from 'src/constants/calendar'
import Consent from './Consent'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { stopEnrollLoading } from 'src/redux/slices/class/detail'

dayjs.extend(utc)

export const getError = (formError, obj) => {
  const error = _.find(formError, (ele) => {
    return ele.path == obj
  })
  return error?.message || ''
}

export const handleDownload = async (title, url, type) => {
  if (type === 'pdf') {
    fetch(url, {
      method: 'get',
      credentials: 'include',
      xhrFields: {
        responseType: 'blob',
      },
    })
      .then((res) => res.blob())
      .then((data) => {
        var a = document.createElement('a')
        var url = window.URL.createObjectURL(data)
        a.href = url
        a.download = `${title}`
        document.body.append(a)
        a.click()
        a.remove()
        window.URL.revokeObjectURL(url)
      })
  } else {
    const a = document.createElement('a')
    a.href = await toDataURL(url)
    a.download = `${title}`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }
}

export const toDataURL = async (url) => {
  const blob = await fetch(url, { credentials: 'include' }).then((res) =>
    res.blob(),
  )
  return URL.createObjectURL(blob)
}

export const fetchLearnerDocument = (payload) => async (dispatch) => {
  dispatch(startLoading())
  if (payload.classLearner) await dispatch(getLearnerDocument(payload))
  else await dispatch(getRegisterDocument(payload.uuid))
  dispatch(stopLoading())
}

export const handleExpiredDate = (dateData) => {
  const date = dayjs(dateData).utc()
  const month = MONTH_TH_SHORT_LIST[date?.get('month')]
  const buddistYear = date?.get('year') + 543
  return `${date?.get('date')} ${month} ${buddistYear}`
}

export const handleConsent = () => (dispatch) => {
  dispatch(
    openDialog({ type: 'custom', customWidth: '85%', content: <Consent /> }),
  )
}

export const handleSocketResponse = (res, error) => (dispatch) => {
  dispatch(stopLoading())
  if (_.isEmpty(res)) return
  if (res.success) dispatch(handleSuccess(res))
  else dispatch(handleError(error))
}

export const handleErrorSocket = (error, params) => (dispatch) => {
  dispatch(stopLoading())
  dispatch(stopEnrollLoading())
  dispatch(stopLoadingDialog())
  dispatch(stopQueueWaiting())
  if (!error) return
  const title = _.get(error, 'title', 'ไม่สำเร็จ')
  const message = _.get(error, 'value', 'ดำเนินการไม่สำเร็จ')
  dispatch(
    openErrorDialog({
      title,
      message: message.split(' '),
      buttonRight: {
        handleClick: () => (window.location.href = params),
      },
    }),
  )
}

export const handleError = (error) => (dispatch) => {
  if (!error) return
  const title = _.get(error, 'constraints.title', 'ไม่สำเร็จ')
  const message = _.get(error, 'constraints.value', 'ดำเนินการไม่สำเร็จ')
  dispatch(
    openErrorDialog({
      title,
      message: message.split(' '),
      buttonRight: {
        handleClick: () => (window.location.href = '/my-class'),
      },
    }),
  )
}

export const handleSuccess = (res, isResend) => (dispatch) => {
  const courseUuid = _.get(res, 'content.courseUuid', '')
  const trainingPlanUuid = isResend
    ? _.get(res, 'uuid', '')
    : _.get(res, 'content.trainingPlanUuid', '')
  const href = isResend
    ? `/my-class/registration-detail/${trainingPlanUuid}`
    : `/course/${courseUuid}/class/${trainingPlanUuid}`
  dispatch(
    openSuccessDialog({
      title: 'ส่งเอกสารสำเร็จ',
      message: ['รอเจ้าหน้าที่ตรวจสอบเอกสาร'],
      handleClick: () => (window.location.href = href),
    }),
  )
}
